import { ballotResponseStore } from '@/services/BallotResponse/store'
import $ from 'jquery'
import _get from 'lodash/get'
import { parseDate } from '@/utilities/Date/parse'
import parseAddress from '@/utilities/address/parse'
import kms from '@/services/kms'
import { notifyProblem, notifyMessage, notifyWarning } from '@/services/notify'
import { base64toBlob, showPdf } from '@/services/blobutility'
import { ballotStore } from '@/services/Ballot/store'
import Menu from './../components/Menu'

export const methods = {
  async reload() {
    console.debug('in reload()')

    this.ballotID = this.$route.params.id

    await this.loadBallotByID().then(async () => {
      await this.loadBallotResponseList()
    })

    console.debug('isSecret=' + this.isSecret)
  },

  async loadBallotResponseList() {
    await ballotResponseStore
      .dispatch('getBallotResponseList', {
        ballotID: this.ballotID
      })
      .then(({ list }) => {
        this.ballotResponseList = list
        this.determineResponseRows(list)
        this.loading = false
      })
  },

  determineResponseRows: function(list) {
    const dateFormat = 'LL'

    let filteredList = list

    var rows = filteredList.map(entry => {
      const ownerName = _get(entry, 'owner.name', '')

      //parse address
      const unitAddress = parseAddress({
        address: _get(entry, 'unit.address', '')
      })

      const suspended = _get(entry, 'suspended', false)

      const vote = this.isSecret === true ? '[Secret Ballot]' : _get(entry, 'vote', '')
      const isHomeOwner = _get(entry, 'isHomeOwner', false)

      //const createdDate = parseDate(_get(entry, 'createdDate', null), dateFormat)

      return {
        ownerName,
        unitAddress,
        vote,
        suspended: suspended === true ? 'Yes' : 'No',
        menu: {
          component: Menu,
          props: {
            hideEdit: this.isSecret === false ? false : true,
            hidePdf: this.isSecret === false ? false : true,
            hideDelete: isHomeOwner === true ? true : false,
            hideSuspend: isHomeOwner === true ? true : false,
            onEditBallotResponse: () => {
              this.editBallotResponse(entry)
            },
            onConfirmDeleteBallotResponse: () => {
              this.confirmDeleteBallotResponse(entry)
            },
            onConfirmSuspension: () => {
              this.confirmSuspension(entry)
            },
            onDownloadPdf: () => {
              this.downloadPdf(entry.ballotResponseID)
            }
          }
        }
      }
    })

    this.rows = rows
  },

  async downloadPdf(ballotResponseID) {
    if (this.isDebug == true) console.debug('downloadPdf...')

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    if (!ballotResponseID || ballotResponseID == undefined) {
      notifyProblem('There was a problem downloading this ballot document.')
    }

    try {
      const params = {
        ballotResponseID: ballotResponseID,
        asBase64: true,
        asRawBase64: true
      }

      const path = `/EVoting/BallotResponse/GetFile`
      const returned = await kms.get(path, {
        params
      })

      if (this.isDebug == true)
        console.debug(
          'path base64 path=' +
            path +
            ' - params' +
            JSON.stringify(params) +
            ' - returned=' +
            JSON.stringify(returned)
        )
      if (returned && returned != undefined) {
        loadingComponent.close()

        if (this.isDebug == true) console.debug('base64pdf........................' + returned)
        const contentType = 'application/pdf'
        const blob = base64toBlob(returned, contentType)
        showPdf(blob)
        notifyMessage(`Successfully downloaded this response document.`)
        return
      }
    } catch (e) {
      if (this.isDebug == true) console.debug(e)
      notifyWarning('There was a problem downloading this response document.')
      loadingComponent.close()
    }

    loadingComponent.close()
  },

  async confirmDeleteBallotResponse(entry) {
    try {
      this.$buefy.dialog.confirm({
        title: 'Deleting Ballot Response',
        message:
          this.isSecret === false
            ? `Are you sure you want to <b>delete</b> this response for ${entry.owner.name ||
                ''}, "${entry.vote || ''}"?`
            : `Are you sure you want to <b>delete</b> this response for ${entry.owner.name ||
                ''}"?`,
        confirmText: 'Delete Ballot Response',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => await this.deleteBallotResponse(entry.ballotResponseID)
      })
    } catch (e) {
      console.debug('There was an issue deleting this response.')
    }
  },

  async confirmSuspension(entry) {
    try {
      const suspended = _get(entry, 'suspended', false)
      if (!suspended) {
        this.$buefy.dialog.confirm({
          title: 'Suspending Ballot Response',
          message:
            this.isSecret === false
              ? `Are you sure you want to <b>suspend</b> this response for ${entry.owner.name ||
                  ''}, "${entry.vote || ''}"?`
              : `Are you sure you want to <b>suspend</b> this response for ${entry.owner.name ||
                  ''}"?`,
          confirmText: 'Suspend Ballot Response',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: async () => await this.suspendBallotResponse(entry.ballotResponseID)
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Un-suspend Ballot Response',
          message:
            this.isSecret === false
              ? `Are you sure you want to <b>un-suspend</b> this response for ${entry.owner.name ||
                  ''}, "${entry.vote || ''}"?`
              : `Are you sure you want to <b>un-suspend</b> this response for ${entry.owner.name ||
                  ''}"?`,
          confirmText: 'Un-suspend Ballot Response',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: async () => await this.suspendBallotResponse(entry.ballotResponseID)
        })
      }
    } catch (e) {
      console.debug('There was an issue deleting this response.')
    }
  },

  async suspendBallotResponse(ballotResponseID) {
    try {
      await ballotResponseStore.dispatch('suspendBallotResponse', {
        ballotResponseID,
        done: () => {
          this.loading = false
          this.reload()
        }
      })
    } catch (e) {
      console.debug('There was an issue suspending this ballot response.')
    }
  },

  async deleteBallotResponse(ballotResponseID) {
    try {
      await ballotResponseStore.dispatch('deleteBallotResponse', {
        ballotResponseID,
        done: () => {
          this.loading = false
          this.reload()
        }
      })
    } catch (e) {
      console.debug('There was an issue deleting this ballot response.')
    }
  },

  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[array[i], array[j]] = [array[j], array[i]]
    }
    return array
  },

  open() {
    this.isOpen = true
    this.loading = false
  },

  closeModal() {
    this.$emit('update:toggle', (this.documentToggle = !this.documentToggle))

    // auto-close modal
    $('#clickclose').click()
  },

  async editBallotResponse(entry) {
    this.selectedBallotResponse = entry
    this.isHomeOwner = entry.isHomeOwner
    this.toggle = true
  },

  async createBallotResponse() {
    this.selectedBallotResponse = null
    this.toggle = true
  },

  async printBallotResponses(includeSuspendedRecords) {
    this.loading = true

    try {
      if (this.ballotResponseList) {
        const params = {
          ballotID: this.ballotID,
          hoaID: this.hoaId,
          unitID: null,
          returnSuspended: includeSuspendedRecords === true ? true : false
        }

        await ballotResponseStore.dispatch('getMergedShuffledBallots', {
          params,
          done: ({ details }) => {
            if (details) {
              const contentType = 'application/pdf'
              const blob = base64toBlob(details, contentType)
              showPdf(blob)
            }
          }
        })
      }
    } catch (error) {
      this.loading = false
      console.error('There was an issue getting the combined documnents pdf.' + error)
    }

    this.loading = false
  },

  async loadBallotByID() {
    await ballotStore
      .dispatch('getBallotById', {
        ballotID: this.ballotID
      })
      .then(async ({ result }) => {
        if (result) {
          this.isSecret = _get(result, 'isSecret', false)
        }
      })
  }
}
